import React, { useState } from 'react'
import { Comment, Subtitle, Text, Wrapper } from './OngoingBooksSubtitle.style'
import { useTranslation } from 'i18n'
import { ButtonIcon } from '@arvoreeducacao/bonsai-ds'
import OrientationPopOver from '../orientation-pop-over'
import OrientationModal from '../orientation-modal'

const OngoingBooksSubtitle: React.FC = () => {
  const { t } = useTranslation()
  const [openOrientation, setOpenOrientation] = useState(false)
  return (
    <Wrapper>
      <Subtitle>
        <Text>
          <strong>{t('Já terminou de ler? ')}</strong>
        </Text>
        <Comment>
          <Text>{t('Marque seu livro como lido.')}</Text>
          <div style={{ position: 'relative' }}>
            <ButtonIcon
              data-testid={'info-button'}
              theme={{ type: 'ghost', size: 'medium' }}
              iconName={'information'}
              aria-label={t('Mais informações')}
              onClick={() => {
                setOpenOrientation(true)
              }}
            />
            <OrientationPopOver
              open={openOrientation}
              onClickOutSide={() => setOpenOrientation(false)}
            />
            <OrientationModal
              open={openOrientation}
              onClose={() => setOpenOrientation(false)}
            />
          </div>
        </Comment>
      </Subtitle>
    </Wrapper>
  )
}
export default OngoingBooksSubtitle
